module.exports = __webpack_public_path__ + "static/img/clients-icon-15.2c8687b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients-icon-15.png
// module id = 55
// module chunks = 0